import { Component, OnInit } from '@angular/core';
import { FluxRssService } from 'app/shared/services/flux-rss/flux-rss.service';
import { TitleService } from 'app/shared/services/title/title.service';
import { faSearch, faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { SportySkyService } from 'app/shared/services/sportySky/sporty-sky.service';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { startWith, map } from 'rxjs/operators';
import { Spot } from 'app/shared/models/SportySky/spotSportySky';
import { DataService } from 'app/shared/services/data/data.service';

@Component({
  selector: 'app-meteo',
  templateUrl: './meteo.component.html',
  styleUrls: ['./meteo.component.scss'],

})
export class MeteoComponent implements OnInit {

  faSearch = faSearch;
  faChevronLeft = faChevronLeft;
  faChevronRight = faChevronRight;

  date = new Date();

  meteo: Spot[];
  myControl = new FormControl();
  options: string[] = [];
  filteredOptions: Observable<string[]>;
  meteoDetail = false;

  actu: any;
  city: Spot;

  constructor(
    private fluxRss: FluxRssService,
    private titleService: TitleService,
    private sporty: SportySkyService,
    private dataService: DataService) {
  }

  ngOnInit(): void {
    // this.getFlux();
    this.getWeather();
    this.titleService.title.next('Météo');
    this.filterOption();
  }

  getDetails(e): void {
    const city = e.target.value.toLowerCase();

    const cityExist = this.meteo.find(el => {
      return el.title.toLowerCase() === city;
    });

    if (e.charCode === 13 && city !== '') {
      if (cityExist) {
        this.meteoDetail = true;
        this.meteo.forEach(item => {
          if (city === item.title.toLowerCase()) {
            this.city = item;
          }
        });
      } else {
        this.meteoDetail = false;
      }
    }


  }

  private filterOption(): void {
    this.filteredOptions = this.myControl.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value))
    );
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.options.filter(option => option.toLowerCase().indexOf(filterValue) === 0);
  }

  private getWeather(): void {
    this.sporty.getAllByCountry().subscribe(res => {
      this.meteo = res.spots;
      res.spots.forEach(item => {
        this.options.push(item.title);
      });

    });
  }
}
